<script setup lang="ts">
const pageContextKey = useCustomerContextKey()
useAppDocumentTitle()
</script>

<script lang="ts">
// Global plugins or components can be imported here if needed
const messages = ref<
  {
    message: string
    clickable: boolean
    onClick?: () => void
    actionLabel?: string
    actionAriaLabel?: string
    onAction?: () => void
    durationMs?: number
  }[]
>([])

const browserMessage = ref<string[]>([])

export const triggerMessage = (newMessage: {
  message: string
  clickable?: boolean
  onClick?: () => void
  actionLabel?: string
  actionAriaLabel?: string
  onAction?: () => void
  durationMs?: number
}) => {
  $log('TriggerMessage aufgerufen:', newMessage)

  document.querySelectorAll('[id=notification-container]').forEach((el) => {
    el.remove()
  })

  const notification = {
    clickable: false,
    ...newMessage,
  }
  messages.value.push(notification)
}

export const triggerBrowserMessage = (newMessage: string) => {
  document.querySelectorAll('[id=browser-message]').forEach((el) => {
    el.remove()
  })
  browserMessage.value.push(newMessage)
}
</script>

<template>
  <div class="content">
    <NuxtLayout>
      <NuxtPage :key="pageContextKey" />
    </NuxtLayout>
    <div
      v-for="(msg, index) in browserMessage"
      id="browser-message"
      :key="index"
    >
      <BrowserPopup :message="msg" />
    </div>

    <div
      v-for="(msg, index) in messages"
      id="notification-container"
      :key="index"
    >
      <Notification
        :message="msg.message"
        :clickable="msg.clickable || false"
        :on-click="msg.onClick || (() => {})"
        :action-label="msg.actionLabel"
        :action-aria-label="msg.actionAriaLabel"
        :on-action="msg.onAction"
        :duration-ms="msg.durationMs"
      />
    </div>
  </div>
</template>

<style scoped>
input,
textarea,
select,
button {
  all: unset; /* Setzt alle Default-Stile zurück */
}

input[type="text"] {
  -moz-appearance: none; /* Deaktiviert Firefox-spezifische Stile */
}
</style>
